import React, {useState, useEffect} from 'react'
import { IoCopyOutline } from 'react-icons/io5'
import { RiFolderZipLine } from 'react-icons/ri'
import {useAuth} from '../../index'
import axios from 'axios'
import postscribe from 'postscribe'
// import IndexedJSONTS from '../python/database_json/client/DatabaseJSON'
import { IoIosCloud } from 'react-icons/io'
import { IoCloudOutline,IoUmbrellaOutline } from 'react-icons/io5'
import { TbBrowser, TbFileCode2 } from 'react-icons/tb'
import productList from '../../util/products.json'
import DbJson from '../node/db_json'
import DbJsonGen from '../node/db_json_gen'
import DbCSV from '../node/db_csv'
import DbPg from '../node/db_pg'
import DbMysql from '../node/db_mysql'
import DbCloudMg from '../node/db_cloud_mg'
import { FiCloudRain } from 'react-icons/fi'
import { MdWbSunny } from 'react-icons/md' 
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function StockPage() {
  const {shoppingCart1, shoppingCart2, auth2FA1, user2, logout} = useAuth()
  const [userInfo, setUserInfo] = useState(null)
  const [msg, setMsg] = useState('')
  const [loadML, setLoadML]=useState(false)
  const [shoppingCart3, setShoppingCart3] = useState([])
  useEffect(() => {
    if(userInfo==null){
      const handleSubmit = async (e) => {
        const { data: res } = await axios.post(`${APIURL}/account-info`, {token:window.localStorage.getItem('token')})
        if(res.msg==='user info ok'){    
          setUserInfo(res.user)
        }else{
          setMsg(res.msg)
          setTimeout(() => {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            logout()
          }, 3000)
        }
      }
      setTimeout(handleSubmit, 1)
    }
    if(!loadML){
      // setTimeout(getMl, 2)
      setLoadML(true)
    }
    setShoppingCart3(shoppingCart2)
  },[shoppingCart2])
  const onClick2AddCodeProduct=(x1)=>{
    if (shoppingCart2!=[]) {
      const existedItem = shoppingCart2.find((x)=>x.id==x1.id)
      if(!existedItem){
        setShoppingCart3([...shoppingCart2, {"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}])
        shoppingCart1([...shoppingCart2, {"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}])
      }
    }else {
      console.log('item is already in cart')
    }
  }
  
  // const getMl = async()=>{
  //    const { data: res } = await axios.get(`${APIURL}/get-ml`)
  //    setStockForecast(res.data)
  // }
  var d=new Date()
  d.setMonth(d.getMonth()-3)
  return(
    <div className='text-left ml-[4px] mr-[4px] sm:mt-8 sm:m-auto w-auto md:w-[580px] lg:w-[780px]'>
        <h2 className='mb-4 flex text-lg structure__main__subttl'>S&P 500 (SPX) API</h2>
        <div className='mb-8 text-xs'>
          symbol list<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/list`} target='_blank'>{APIURL}/api/spx/list</a>
          </pre>
         <br/>
          profile<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/info`} target='_blank'>{APIURL}/api/spx/info</a>
          </pre>
         <br/>
          the latest<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx`} target='_blank'>{APIURL}/api/spx</a><br/>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl`} target='_blank'>{APIURL}/api/spx/[symbol]</a>
          </pre>
         <br/>
          daily<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1d`} target='_blank'>{APIURL}/api/spx/[symbol]/1d</a><br/>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1d/2010-12-01/${new Date().toISOString().split('T')[0]}`} target='_blank'>{APIURL}/api/spx/[symbol]/1d/2010-12-01/{new Date().toISOString().split('T')[0]}</a>
          </pre>
         <br/>
          monthly<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1m`} target='_blank'>{APIURL}/api/spx/[symbol]/1m</a><br/>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1m/2010-12-01/${new Date().toISOString().split('T')[0]}`} target='_blank'>{APIURL}/api/spx/[symbol]/1m/2010-12-01/{new Date().toISOString().split('T')[0]}</a>
          </pre><br/>
          yearly<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1y`} target='_blank'>{APIURL}/api/spx/[symbol]/1y</a><br/>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/1y/2010-12-01/${new Date().toISOString().split('T')[0]}`} target='_blank'>{APIURL}/api/spx/[symbol]/1y/2010-12-01/{new Date().toISOString().split('T')[0]}</a>
          </pre><br/>
          Machine Learning +3month prediction stock graph items<br/>
          <pre className='primary-code-container'>
            [GET] <a className='underline cursor-default' href={`${APIURL}/api/spx/aapl/graph`} target='_blank'>{APIURL}/api/spx/[symbol]/graph</a>
          </pre><br/>
        </div>
    </div>
  )
}

